<div class="bg-tl-blue h-14"></div>

<div class="bg-tl-grey py-6 px-6">
  <div class="container mx-auto">
    <div class="space-y-1">
      <p class="text-tl-dark-blue font-bold text-xl">Translate PDF</p>
      <p class="text-gray-500 text-sm">Upload a PDF document and select a language for translation</p>
    </div>
  </div>
</div>

<div class="container mx-auto py-8">
  <div class="max-w-2xl mx-auto">
    <div class="bg-white rounded-xl border p-6 shadow-sm">
      
      <!-- Upload Section -->
      <div class="mb-6">
        <label class="block text-tl-dark-blue font-semibold mb-3">Upload PDF</label>
        
        <div 
          class="border-2 border-dashed border-gray-300 rounded-xl p-8 text-center transition-colors hover:border-tl-button-blue"
          (dragover)="$event.preventDefault()"
          (drop)="onDrop($event)"
        >
          @if (uploadedFile) {
            <div class="flex items-center justify-center gap-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-12 h-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
              <div class="text-left">
                <p class="text-tl-dark-blue font-medium">{{ uploadedFile.name }}</p>
                <p class="text-gray-500 text-sm">{{ (uploadedFile.size / 1024 / 1024).toFixed(2) }} MB</p>
              </div>
              <button 
                (click)="removeFile()"
                class="ml-4 text-red-500 hover:text-red-700 p-2"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          } @else {
            <svg xmlns="http://www.w3.org/2000/svg" class="w-12 h-12 mx-auto text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
            </svg>
            <p class="text-gray-600 mb-2">Drag and drop your PDF here, or</p>
            <label class="inline-block">
              <input 
                type="file" 
                accept=".pdf"
                (change)="onFileSelected($event)"
                class="hidden"
              />
              <span class="cursor-pointer text-tl-button-blue font-semibold hover:underline">browse files</span>
            </label>
          }
        </div>
      </div>

      <!-- Language Dropdown -->
      <div class="mb-6">
        <label class="block text-tl-dark-blue font-semibold mb-3">Select Language</label>
        <select 
          [(ngModel)]="selectedLanguage"
          class="w-full px-4 py-3 border border-gray-300 rounded-lg text-black focus:outline-none focus:border-tl-button-blue shadow-[2px_2px_0px_0px_rgba(137,137,137,1)]"
        >
          <option value="" disabled>Choose a language</option>
          @for (lang of languages; track lang.code) {
            <option [value]="lang.code">{{ lang.name }}</option>
          }
        </select>
      </div>

      <!-- Submit Button -->
      <div class="text-center">
        <button 
          (click)="onSubmit()"
          [disabled]="isSubmitting || !uploadedFile || !selectedLanguage"
          class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] text-white rounded-[1.5rem] text-sm px-10 font-bold py-2.5 text-center bg-tl-button-blue focus:outline-none disabled:opacity-50 uppercase tracking-wide"
        >
          @if (isSubmitting) {
            <app-loading-spinner></app-loading-spinner>
          } @else {
            Submit
          }
        </button>
      </div>
      
    </div>
  </div>
</div>
